import React, { useState } from 'react';
import Icon from '@components/AppIcon';
import Button from '@components/ui/Button';

const InteractiveMap = ({ locations, selectedLocation, onLocationSelect }) => {
  const [mapView, setMapView] = useState('satellite');

  return (
    <div className="bg-white rounded-xl medical-shadow overflow-hidden">
      {/* Map Header */}
      <div className="p-4 border-b bg-muted">
        <div className="flex items-center justify-between">
          <h3 className="font-heading font-bold text-lg text-text-primary">
            Eye&U Kenya Locations
          </h3>
          <div className="flex items-center space-x-2">
            <Button
              variant={mapView === 'satellite' ? 'default' : 'outline'}
              size="xs"
              onClick={() => setMapView('satellite')}
            >
              Satellite
            </Button>
            <Button
              variant={mapView === 'roadmap' ? 'default' : 'outline'}
              size="xs"
              onClick={() => setMapView('roadmap')}
            >
              Roadmap
            </Button>
          </div>
        </div>
      </div>

      {/* Map Container */}
      <div className="relative h-96">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Eye&U Kenya Clinic Locations"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=-1.2614777,36.7916603&z=17&output=embed&maptype=${mapView}
`}
          className="border-0"
        />
        
        {/* Location Markers Overlay */}
        <div className="absolute inset-0 pointer-events-none">
          {locations.map((location, index) => (
            <div
              key={location.id}
              className={`absolute transform -translate-x-1/2 -translate-y-1/2 pointer-events-auto cursor-pointer ${
                selectedLocation?.id === location.id ? 'z-20' : 'z-10'
              }`}
              style={{
                left: `${20 + (index * 15)}%`,
                top: `${30 + (index * 10)}%`
              }}
              onClick={() => onLocationSelect(location)}
            >
              <div className={`relative ${
                selectedLocation?.id === location.id ? 'scale-125' : 'hover:scale-110'
              } medical-transition`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shadow-lg ${
                  selectedLocation?.id === location.id 
                    ? 'bg-primary text-white' :'bg-white text-primary border-2 border-primary'
                }`}>
                  <Icon name="MapPin" size={16} />
                </div>
                {selectedLocation?.id === location.id && (
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white rounded-lg shadow-lg p-3 min-w-48 border">
                    <h4 className="font-heading font-semibold text-sm text-text-primary mb-1">
                      {location.name}
                    </h4>
                    <p className="text-xs text-text-secondary mb-2">
                      {location.address}
                    </p>
                    <div className="flex items-center space-x-2 text-xs text-text-secondary">
                      <Icon name="Clock" size={12} />
                      <span>{location.hours}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Map Legend */}
      <div className="p-4 bg-surface border-t">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 bg-primary rounded-full"></div>
              <span className="text-text-secondary">Eye&U Clinics</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="AlertCircle" size={16} className="text-error" />
              <span className="text-text-secondary">Emergency Care (During Opening Hours)</span>
            </div>
          </div>
          <div className="text-text-secondary">
            {locations.length} locations across Nairobi
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMap;